<template>
    <!--页面加载动画-->
    <div class="select-box">
        <template v-if="type == 1">
            <template v-for="(item, i) in arrs">
                <div
                    v-if="defaultIndex == i"
                    :class="['drop-' + arrs.length, 'lz-drop-check active']"
                    @click="check(i)"
                >
                    {{ item.name }}
                </div>
                <div
                    v-else
                    :class="['drop-' + arrs.length, 'lz-drop-check']"
                    @click="check(i)"
                >
                    {{ item.name }}
                </div>
            </template>
        </template>
        <template v-if="type == 2">
            <span class="defaultTxt" @click.stop="closeLayer">
                {{ defaultTxt }}
                <i class="iconfont iconzhankai-xianxing"></i>
            </span>
            <div class="select-layer-box" v-show="showLayer">
                <div class="mask" @click.stop="showLayer = false"></div>
                <div class="mainContent">
                    <van-picker
                        show-toolbar
                        :title="title"
                        :columns="columns"
                        :default-index="defaultIndex"
                        value-key="name"
                        @cancel="handleCancle"
                        @confirm="handleSure"
                    />
                </div>
            </div>
        </template>
    </div>
</template>

<script>
import _ from "lodash"; //lodash.js
export default {
    data() {
        return {
            type: 0,
            defaultIndex: 0,
            arrs: new Array(), //选择元素
            showLayer: false, //是否弹窗选择框
            defaultTxt: "", //是否弹窗选择框
            checkItem: new Object(), //当前滑动选择项
            title: "", //弹窗顶部标题
        };
    },
    props: ["selectData", "parentItem"],
    mounted() {
        this.arrs = this.selectData.elementItems || [];
        this.checkType();
        this.checkDefault();
        this.title = this.selectData.elementName || "";
    },
    computed: {
        columns() {
            let data = this.selectData.elementItems;
            return data;
        },
    },
    methods: {
        handleSure(e) {
            //munt 选择回调-确认
            console.log(e);
            this.showLayer = false;
            this.defaultTxt = e.name;
            this.defaultIndex = _.findIndex(this.arrs, (item) => {
                item.value === e.value;
            });
            this.checkItem = e;
            this.getResult();
        },
        closeLayer() {
            setTimeout((_) => {
                //按钮选择
                this.showLayer = true;
            }, 100);
        },
        handleCancle() {
            //munt 选择回调-取消
            this.showLayer = false;
        },
        checkType() {
            //根据数组长度和数组内每个数据的长度，判断单选是按钮还是滑动弹窗
            let arr = this.arrs;
            if (arr.length > 9) {
                this.type = 2;
                return;
            }
            var names = "";
            for (var k in arr) {
                names += arr[k].name;
            }
            if (names.length > 30) {
                this.type = 2;
                return;
            }
            this.type = 1;
        },
        checkDefault() {
            //检测和设置默认值
            let arr = this.arrs;
            const value = this.selectData.elementValue;
            let index = arr.findIndex((item) => {
                return item.value == value;
            });
            if (index > -1) {
                this.defaultIndex = index;
            } else {
                this.defaultIndex = -1;
                this.selectData.elementValue = "";
            }

            if (this.type == 2) {
                this.defaultTxt = index > -1 ? this.arrs[index].name : "请选择";
            }
        },
        check(i) {
            //按钮选择
            this.defaultIndex = i;
            this.checkItem = this.arrs[i];
            if (
                (this.selectData.elementCode == "holderChineseResident" ||
                    this.selectData.elementCode == "insurersChineseResident") &&
                i == 1
            ) {
                let msg = "本产品仅支持中国税收居民";
                this.$notice.msg(msg);
                this.selectData.errorMsg = msg;
            } else {
                this.selectData.errorMsg = "";
            }
            this.getResult();
        },
        getResult() {
            //选择后回调到父组件
            let value = this.checkItem.value;
            this.selectData.elementValue = value;
            if (this.checkItem.msg) {
                this.$notice.alert(this.checkItem.msg);
            }
            this.$emit("selected", {
                type: 1,
                item: this.selectData,
                value: value,
            });
            this.setAbouts(value);
        },
        setAbouts(value) {
            let aboutElement = this.selectData.aboutElement;
            if (
                aboutElement &&
                _.isArray(aboutElement) &&
                aboutElement.length > 0
            ) {
                aboutElement.forEach((item) => {
                    this.$emit("selected", {
                        type: item.isBlock ? 3 : 2,
                        id: item.code,
                        parentCode: this.parentItem.elementPath,
                        value: this.needHide(value, item.value),
                    });
                });
            }
        },
        needHide(value, allValues) {
            let list = allValues.split(",");
            let index = list.findIndex((item) => {
                return value == item;
            });
            return index > -1;
        },
    },
    watch: {
        selectData(newVal) {
            this.arrs = newVal.elementItems;
            this.checkType();
            this.checkDefault();
        },
    },
};
</script>

<style lang="scss" scoped>
.select-box {
    width: 100%;
    height: 100%;
    .lz-drop-check {
        text-align: center;
        cursor: pointer;
        min-width: 130px;
        height: 100%;
        font-size: 30px;
        line-height: 54px;
        box-shadow: 0 0 3px 0 rgba(0, 132, 255, 0.5);
        padding: 0 15px;
        color: #666;
        display: inline-block;
        margin: 5px 8px 5px 0;
        background-color: #fff;
        border-radius: 60px;
        &.active {
            color: #fff;
            background-color: #0084ff;
        }
    }
    .drop-2 {
        min-width: 45%;
    }
    .iconfont {
        position: absolute;
        right: 0;
        top: 50%;
        transform: translateY(-50%);
        color: #999;
        font-size: 36px;
    }
}
.defaultTxt {
    width: 100%;
    height: 100%;
    line-height: 40px;
    font-size: 30px;
    padding-top: 10px;
    padding-bottom: 10px;
    padding-right: 50px;
    display: inline-block;
    cursor: pointer;
}

.select-layer-box {
    width: 100%;
    height: 100%;
    position: fixed;
    top: 0;
    left: 0;
    z-index: 1000;
    .mask {
        position: absolute;
        left: 0;
        top: 0;
        width: 100%;
        height: 100%;
        background-color: rgba($color: #000000, $alpha: 0.5);
        z-index: 1;
    }
    .mainContent {
        position: absolute;
        width: 375px;
        left: 50%;
        bottom: 0;
        z-index: 2;
        background-color: #fff;
        transform: scale(2) translateX(-50%);
        transform-origin: left bottom;
    }
}
</style>
